import React, { useEffect } from 'react';

import Filters from '../Filters';
import Loader from '../../../Shared/Loader';
import TeamPlayersTable from './TeamPlayersTable';
import { saveDataPlayersOnLocalStorage } from '../../../../helpers/helpers';
import { FILTER_GLOBAL_KEYS, FILTER_KEYS } from '../../../../config/constants';
import {
  useDataPlayersDispatch,
  useDataPlayersState,
  useDataTeamsState,
  useFiltersState
} from '../../../../store/hooks';
import { useRouter } from '../../../../helpers/customHooks';

const PlayerGamesTab = () => {
  
  const { specificScope } = useRouter();
  const { dataPlayers } = useDataPlayersState();
  const {
    [FILTER_GLOBAL_KEYS.WEEKS]: weeks,
    [FILTER_KEYS.DATE_RANGE]: filterDateRangeData,
    [FILTER_KEYS.POSITIONS]: filterPositionsData
  } = useFiltersState(specificScope, FILTER_GLOBAL_KEYS.WEEKS, FILTER_KEYS.DATE_RANGE, FILTER_KEYS.POSITIONS);
  const { dataTeam: team } = useDataTeamsState();
  const { getDataPlayersByTeamId } = useDataPlayersDispatch();
  
  useEffect(() => {
    if (team && team.teamId && filterDateRangeData && weeks && filterDateRangeData.selectedDates && filterDateRangeData.selectedDates.length && filterPositionsData) {
      getDataPlayersByTeamId(team.teamId, 'Game')();
    }
  }, [weeks, filterDateRangeData]);
  useEffect(() => {
    saveDataPlayersOnLocalStorage();
  }, [dataPlayers]);
  useEffect(() => {
    if(team && team.teamId){
      getDataPlayersByTeamId(team.teamId, 'Game')();
    }
  }, [team.teamId]);
  const headers = [
    { content: 'PLAYER', style: { width: '300px' }, class: 'oo-i', isOrderly: true, leftSortIcon: '71px' },
    { content: 'NO.', style: { width: '51px' }, isOrderly: true },
    { content: 'POS.', style: { width: '51px' }, isOrderly: true },
    { content: 'MAX SPEED', style: { width: '90px' }, class: 'll-pp', isOrderly: true },
    { content: 'MAX SUST. SPEED', style: { width: '101px' }, class: 'll-pp', isOrderly: true },
    { content: 'TTL. DIST.', style: { width: '76px' }, class: 'll-pp', isOrderly: true },
    // { content: 'HARD EFF. DIST.', style: { width: '82px' }, class: 'll-pp', isOrderly: true },
    { content: 'ACCEL CT.', style: { width: '50px' }, class: 'll-pp', isOrderly: true },
    { content: 'DECEL CT.', style: { width: '50px' }, class: 'll-pp', isOrderly: true },
    { content: '', style: { width: '507px' } }
  ];
  
  return (
    <>
      <Filters />
      <div className="performance-body" style={{ height: 'calc(100vh - 175px)' }}>
        <Loader forceLoader={!weeks}>
          <TeamPlayersTable headers={headers} dataPlayers={dataPlayers} />
        </Loader>
      </div>
    </>
  );
};

export default PlayerGamesTab;